



































































































































































































































































































































































































import {Component, Prop, Ref, Vue, Watch} from 'vue-property-decorator'
import {Action, Getter} from "vuex-class";
import {DateTime} from "luxon";
import {cloneDeep, omit, isEqualWith} from "lodash";
import {CollapseTransition} from "vue2-transitions";
import {
  Collapse,
  DatePickerWings,
  FieldTooltip, InputWings,
  SelectWings,
  SpoilerWings,
  TimeoutWings,
  ToggleWings
} from 'wings-ui-components';
import {SmsTextInputWings} from '@/components/SMS';
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {TemplateItem, CallTemplateItemImpl} from '@/store/settings/templates/types';
import {MsgTransports} from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";
import {convertTimeToMinutes, convertMinutesToTime} from "@/utils/date-util";
import {ActionLog} from "@/store/auth/types";
import MaskingTemplate from "@/components/Templates/MaskingTemplate.vue";
import BlackListSelection from "@/pages/Pages/Templates/BlackListSelection.vue";
import {BlacklistItem} from "@/store/settings/blacklists/types";
import CloneTemplateDialog from "@/components/Templates/CloneTemplateDialog.vue";
import AdditionalParamsCard from "@/pages/Pages/Templates/AdditionalParamsCard.vue";

@Component({
  components: {
    BlackListSelection,
    MaskingTemplate,
    AdditionalParamsCard,
    FieldTooltip,
    SelectWings,
    DatePickerWings,
    ToggleWings,
    Collapse,
    SpoilerWings,
    SmsTextInputWings,
    CollapseTransition,
    TimeoutWings,
    CloneTemplateDialog,
    InputWings
  }
})
export default class GenericTemplate extends Vue {
  @Ref('validator') validator: any;
  @Prop() moderation!: boolean;
  @Prop() transport!: MsgTransports;
  @Prop() templateObject!: TemplateItem;

  @Getter("priorityList") priorityList: any;
  @Getter("deliveryTypeList") deliveryTypeList: any;
  @Getter("messageTypes") messageTypesList: any;
  @Getter("transportsMultichannel") transportsMultichannelList: any;
  @Getter("multichannelTemplates") multichannelTemplatesList: any;

  @Action("getTemplateItem") actionGetTemplateItem: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnerUsers: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("getBlacklists") actionGetBlackLists: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getTransportsMultichannel") actionGetTransportsMultichannel: any;
  @Action("getMultichannelTemplates") actionGetMultichannelTemplates: any;

  @Action("saveTemplate") actionSaveTemplate: any;
  @Action("deleteTemplate") actionDeleteTemplate: any;
  @Action("actionLog") actionLog: any;

  private emailTransport: MsgTransports = MsgTransports.EMAIL;
  private pushTransport: MsgTransports = MsgTransports.PUSH;
  private mailNotifyTransport: MsgTransports = MsgTransports.MAILNOTIFY;

  defaultTemplate(): TemplateItem {
    return this.templateObject
  }

  public template = this.defaultTemplate();
  private templateSaved = this.defaultTemplate();
  private weekDays = [
    {value: 'MON'},
    {value: 'TUE'},
    {value: 'WED'},
    {value: 'THU'},
    {value: 'FRI'},
    {value: 'SAT'},
    {value: 'SUN'}
  ];
  private is_cascading = false;
  private multichannel_chanel = '';
  private logObject: ActionLog = {};
  private isShowCloneTemplate = false
  private cloneTemplateError: any = null

  partnersList: any = []
  originatorsList: any = []
  partnerUsersList: any = [];
  blackLists: BlacklistItem[] = [];
  multichannelTemplateList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({transport: this.transport, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    const items = await this.actionGetOriginators({partner_id: this.template.partner_id, transport: this.transport, ...filter});
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getPartnerUsersList(filter: any) {
    const items = await this.actionGetPartnerUsers({partner_id: this.template.partner_id, ...filter});
    this.partnerUsersList = (filter?.page_number > 1) ? this.partnerUsersList.concat(items) : items
  }

  async getMultichannelTemplateList(filter: any) {
    let transport = this.transportsMultichannelList.find((item: any) => item.id == this.template.multichannel_id)?.name ?? '';
    const items = await this.actionGetMultichannelTemplates({
      transport: transport.toLowerCase(),
      filter: {
        partner_id: this.template.partner_id,
        is_active: 1,
        ...filter
      }
    });
    this.multichannelTemplateList = (filter?.page_number > 1) ? this.multichannelTemplateList.concat(items) : items
  }

  async created() {
    this.templateSaved= cloneDeep(this.template);
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Template",
          addititional_info: getTranslatedParams(this.template, {'is_active': 'active', 'save_text': 'statistic'})
        }
        const data = await this.actionGetTemplateItem({id: this.$route.params.id, transport: this.transport});
        if (data.custom_data) data.custom_data = JSON.stringify(data.custom_data);

        if (this.transport === MsgTransports.CALL && 'retry_timeout' in data && typeof (data as CallTemplateItemImpl).retry_timeout === 'number') {
          const retryVal = (data as CallTemplateItemImpl).retry_timeout;
          Object.assign(data, { retry_timeout: retryVal ? convertMinutesToTime(retryVal) : null });
        }

        this.template=Object.assign({},this.template, data);
        this.templateSaved= cloneDeep(Object.assign({},this.template, data));
        this.logObject.object_name = this.template.name;
        this.actionLog(this.logObject);
        if (this.template.blacklist_ids?.length) {
          this.blackLists = await this.actionGetBlackLists({ids: String(this.template.blacklist_ids)});
        }
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
      }
      this.$emit('onChangeTemplate', this.template);
      if (this.template.multichannel_template_id || this.template.multichannel_id) {this.is_cascading = true}
      if (this.moderation) this.$emit('onLoadTemplate', this.template.status)

      if (this.template.partner_id) this.partnersList = await this.actionGetPartners({id: this.template.partner_id});
      if (this.template.originator_id) this.originatorsList = await this.actionGetOriginators({id: this.template.originator_id});
      if (this.template.partner_user_id) this.partnerUsersList = await this.actionGetPartnerUsers({id: this.template.partner_user_id});

      let transport = this.transportsMultichannelList.find((item: any) => item.id == this.template.multichannel_id)?.name ?? '';
      if (this.template.multichannel_template_id) this.multichannelTemplateList = await this.actionGetMultichannelTemplates({
        transport: transport.toLowerCase(),
        filter: {id: this.template.multichannel_template_id}
      });
    }
    this.actionGetMessageTypes();
  }

  back():void{
    this.$router.push(`/${this.transport.toLowerCase()}/templates/`);
  }

  onSaveItem(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Template",
            object_name : this.template.name,
            addititional_info: getTranslatedParams(this.template)
          }
          if (this.$route.params.id) {
            this.template.blacklist_ids = this.blackLists
                .filter((item: BlacklistItem) => item.is_public === 1 && item.id !== undefined)
                .map((e: BlacklistItem) => e.id as number);
          }
          if (this.template.custom_data) this.template.custom_data = JSON.parse(this.template.custom_data);

          const templateToSave = cloneDeep(this.template);
          if (this.transport === MsgTransports.CALL && 'retry_timeout' in templateToSave) {
            Object.assign(templateToSave, { retry_timeout: convertTimeToMinutes((templateToSave as CallTemplateItemImpl).retry_timeout) });
          }

          await this.actionSaveTemplate({item: templateToSave, transport: this.transport})
          await this.actionLog(this.logObject);
          this.templateSaved = cloneDeep(this.template);
          resolve()
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          reject()
          notifyError(error);
        }
      } else {
        reject();
        notifyError(null, this.validator.errors);
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Template",
          object_name : this.template.name,
          addititional_info: getTranslatedParams({id: this.template.id})
        }
        await this.actionDeleteTemplate({item: this.template, transport: this.transport});
        await this.actionLog(this.logObject);
        this.templateSaved = cloneDeep(this.template);
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  async cloneTemplate(name: string) {
    try {
      let template = { ...omit(this.template, ['id']), name };
      if (template.custom_data) template.custom_data = JSON.parse(template.custom_data);

      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Creation",
        action_status: "success",
        object_type: "Template",
        object_name : template.name,
        addititional_info: getTranslatedParams(template)
      }
      const { data } = await this.actionSaveTemplate({ item: template, transport: this.transport });
      await this.actionLog(this.logObject);
      this.template = { ...this.template, name, id: data.id };
      this.templateSaved = { ...this.templateSaved, name, id: data.id };
      this.isShowCloneTemplate = false;
      this.$router.push(`/${this.transport.toLowerCase()}/templates/${data.id}`);
    } catch (error) {
      this.cloneTemplateError = error;
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  get minEndingDatetime(): string {
    let now = DateTime.local().set({millisecond: 0})
    if (!this.template.starting_datetime) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';
    if (now > DateTime.fromISO(this.template.starting_datetime)) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';

    return this.template.starting_datetime
  }

  get minEndDatetime(): string {
    let now = DateTime.local().set({millisecond: 0})
    if (!this.template.start_datetime) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';
    if (now > DateTime.fromISO(this.template.start_datetime)) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';

    return this.template.start_datetime
  }

  @Watch('template.start_datetime', {immediate: true})
  onChangeStartDateTime(val: string, oldVal?: string) {
    if (!val) {
      this.template.send_evenly = 0
    }
  }

  @Watch('template.end_datetime', {immediate: true})
  onChangeEndDateTime(val: string, oldVal?: string) {
    if (!val) {
      this.template.send_evenly = 0
    }
  }

  @Watch('template.partner_id', {immediate: true})
  async onTemplateChangePartner(val: number, oldVal?: number) {
    if (this.template.partner_id) {
      this.$emit('onPartnerId', this.template.partner_id);
      this.actionGetTransportsMultichannel({transport : this.transport, partner_id: this.template.partner_id});
    }
    if (oldVal && val !== oldVal) {
      this.template.partner_user_id = null;
      this.template.originator_id = null;
      this.template.multichannel_id = null;
      this.template.multichannel_template_id = null;
    }
  }

  @Watch('template.multichannel_id', {immediate: true})
  async onTemplateChangeMultichannel(val: number, oldVal?: number) {
    if (oldVal && val !== oldVal) {
      this.template.multichannel_template_id = null;
    }
  }

  @Watch('is_cascading', {immediate: false})
  onChangeIsCascading(val?: boolean) {
    if (!val) {
      this.template.multichannel_id = null;
      this.template.multichannel_template_id = null;
      this.template.multichannel_timeout = 0;
    }
  }

  onAllowedDaysChange() {
    this.template?.allowed_days?.sort()
    this.templateSaved?.allowed_days?.sort()
  }

  normalizeHtml(html?: string) {
    return html?.replace(/\n/ig, '');
  }

  isTemplateChanged() {
    let templateSaved = this.transport === this.emailTransport
        ? { ...this.templateSaved, message: this.normalizeHtml(this.templateSaved?.message) }
        : { ...this.templateSaved };

    let template = this.transport === this.emailTransport
        ? { ...this.template, message: this.normalizeHtml(this.template?.message) }
        : { ...this.template };

    const deepNormalize = (obj: any, visited = new WeakSet()): any => {
      if (obj === null || obj === undefined || visited.has(obj)) return obj;
      if (typeof obj !== 'object') return obj;

      visited.add(obj);

      if (Array.isArray(obj)) {
        const normalized = obj
            .filter((item: any) => item !== '__ob__' && !item?.__ob__)
            .map((item: any) => deepNormalize(item, visited))
            .filter((item: any) => item !== undefined && item !== null);
        return normalized.length === 0 ? undefined : normalized;
      }

      const normalized: Record<string, unknown> = {};
      Object.keys(obj).forEach(key => {
        if (key.startsWith('__')) return;

        let value = obj[key];
        if (value === null || value === '') value = undefined;
        if (value !== undefined && value !== null && typeof value === 'object') {
          value = deepNormalize(value, visited);
        }
        if (value !== undefined) {
          normalized[key] = value;
        }
      });

      return normalized;
    };

    templateSaved = deepNormalize(templateSaved);
    template = deepNormalize(template);

    const savedKeys = Object.keys(templateSaved);
    const templateKeys = Object.keys(template);
    const keysToRemove = [...templateKeys.filter(k => !savedKeys.includes(k)), ...savedKeys.filter(k => !templateKeys.includes(k))];
    keysToRemove.forEach((key: string) => {
      delete (templateSaved as Record<string, unknown>)[key];
      delete (template as Record<string, unknown>)[key];
    });

    const result = isEqualWith(templateSaved, template, function customizer(objValue:any, othValue:any) {
      if ((objValue === null && othValue === '') ||
          (objValue === '' && othValue === undefined) ||
          (objValue === null && othValue === undefined) ||
          (objValue === '' && othValue === null)) return true
      return undefined
    })

    return !result
  }

  beforeLeave(to: any, from: any, next: any) {
    if (to.name) notifyConfirm(this.isTemplateChanged(), this.onSaveItem, next);
    else next();
  }
}
